import $ from 'jquery'
import template from 'lodash.template'
import AjaxList from '../../components/ajaxList'
import { format } from '../../utils/currency'
import { localeDate } from '../../utils/date'

class Module {
  constructor ($module) {
    const self = this
    
    this.$module = $module
    this.$container = $module.find('.js-profile-history_list')
    this.$list = $module.find('.js-profile-history_list_wrap')
    this.$accountSelector = $module.find('.financial_transaction_filter_account')
    this.$account = $module.find('#financial_transaction_filter_account')
    this.$depositLinks = $module.find('.empty_list_msg a')
    this.$form = $module.find('.js-profile-filter-form')
    this.$export = $module.find('.js-export')
    this.template = template($module.find('.js-profile-history-template').html())

    this.list = new AjaxList({
      $container: this.$container,
      $form: this.$form,
      $load: $module.find('.js-load-transactions'),
      append: (response, replace) => {
        this.append(response, replace)
        this.updateSummary(response.summary, response.currency)
      }
    })

    this.$accountSelector.dropdown('setItemHandler', function (e) {
      e.preventDefault()
      self.$account.val($(this).data('value')).trigger('change')
    })

    $('.js-currency').on('changeCurrency', function (e) {
      const $link = $(this)
      const depositUrl = $link.data('deposit-url')

      self.$depositLinks.each(function () {
        $(this).attr('href', depositUrl)
      })
      
      // TODO это костыль чтобы прожить до новой версии кошельков
      // TODO он очищает список операций если пользователь выбрал тип кошелька, который еще не был создан (есть в списке, но отсутствует в базе)
      if (self.$accountSelector.find('a[data-value="' + $link.data('account') + '"]').length > 0) {
        self.$accountSelector.find('a[data-value="' + $link.data('account') + '"]').trigger('click')
      }
      else {
        self.$account.val(undefined)
        self.list.formValue = null
        self.list.paginator.page(1)
        self.list.paginator.total(0)
        const response = {"operations":[],"pagination":{"page":1,"total_pages":0,"sort_field":"_id","sort_direction":-1},"summary":{"payment":0,"partner_payment":0,"award":0,"transfer":0},"currency": $link.data('currency')}
        self.append(response, true)
        self.updateSummary(response.summary, response.currency)
      }
      
    })

    this.$export.on('click', function (e) {
      self.$form.unbind('submit')
      self.$form.submit()
    })
  }

  append (response, replace) {
    
    if (replace) {
      this.$list.empty()
    }

    if (!Object.prototype.hasOwnProperty.call(response, 'operations') || response.operations.length === 0) {
      this.$container.addClass('empty_list')
    } else {
      this.$container.removeClass('empty_list')

      let content = ''
      let prevDate = replace ? null : $.trim(this.$container.find('.b-networks__subtitle:last').text())
      let date = null
      let row = null

      response.operations.forEach((v, index) => {
        date = localeDate(v.transaction.created_at)
        row = this.render(v, date !== prevDate ? date : null)

        content += row
        prevDate = date
      })

      this.$list.append(content)
    }
  }

  updateSummary (data, currency) {
    for (const key in data) {
      if (!Object.prototype.hasOwnProperty.call(data, key)) {
        continue
      }

      const $row = this.$module.find('.js-summary-' + key)

      if (!data[key]) {
        $row.addClass('hidden')
        continue
      }

      $row.removeClass('hidden').find('.js-value').html(format(data[key], currency))
    }
  }

  render (value, date) {
    var amount = value.transaction.amount
    return this.template({
      id: value.id,
      date: date,
      amount: format(amount, value.transaction.currency),
      caption: value.caption,
      details: value.details,
      direction: amount < 0 ? 'out' : 'in',
      iconName: amount < 0 ? 'out' : 'success'
    })
  }
}

$(function () {
  $('.js-profile-history').each(function () {
    new Module($(this))
  })
})
